// Table of Contents scroll behavior (Desktop only, ToC is hidden on mobile)
export const TABLE_OF_CONTENTS = {
  STICKY_TOP_OFFSET: 96, // Fixed pixel offset matching the header height (24px padding * 2 + 48px content = 96px)
  SCROLL_THRESHOLD: 300, // Minimum scroll distance (in px) before showing sticky ToC to prevent flickering on small scrolls
  VIEWPORT_THRESHOLD: 100, // Minimum viewport visibility (in px) required for scroll-triggered actions
  INITIAL_SCROLL_DELAY: 100, // Initial delay (in ms) before scroll-based animations start
  SCROLL_SPY_SUPPRESSION_MS: 1000,
} as const;

export const ANIMATION = {
  DELAY_INCREMENT: 100,
  DURATION: 500,
} as const;

// Intersection Observer for lazy section loading
export const INTERSECTION_OBSERVER = {
  ROOT_MARGIN: "300px 0px 0px 0px", // Margin extending detection zone 300px above viewport
  THRESHOLD: 0.1, // Threshold (10% visibility) triggering activation
} as const;

export const SECTION_IDS = {
  KEY_METRICS: "key-metrics",
  DOCUMENTS: "documents",
  SECTION_PREFIX: "section-",
} as const;
